import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import { useState } from "react";

import StepContainer from "../../ui/StepContainer";
import BottomBar from "../../ui/BottomBar";
import { STEPS } from "../../constants/stepsConstants";
import { getEvaluationType } from "../../util/dataSelectors";
import Header from "../../ui/Header";
import VcTable from "../../ui/VcTable";
import { projectDataPropType } from "../../util/propTypeHelper";
import CapacityReport from "./report/CapacityReport";
import { downloadPennDotIceFormXlsx } from "../../util/excelFileHelper";
import { getVcTableRows } from "../../calculations/vc/vcHelper";
import { STEP_STORAGE_KEYS } from "../../constants/storageConstants";
import {
  ICE_FORM_XLSX_INTX_CAPACITY,
  ICE_FORM_XLSX_INTX_CAPACITY_MESSAGE,
} from "../lifeCycleCost/outputs/outputsHelpers";

export default function CapacityAnalysis({
  handleSecondaryButtonClick,
  projectData,
}) {
  const [showCapacityReport, setShowCapacityReport] = useState(false);
  const closeCapacityReport = () => setShowCapacityReport(false);
  const rows = getVcTableRows(projectData);
  const intersections = projectData[STEP_STORAGE_KEYS.INTERSECTIONS];

  if (showCapacityReport) {
    return (
      <CapacityReport
        onClose={closeCapacityReport}
        projectData={projectData}
        rows={rows}
      />
    );
  }

  return (
    <StepContainer
      activeStep={STEPS.CAPACITY_ANALYSIS}
      evaluationType={getEvaluationType(projectData)}
    >
      <Header
        subtitle="Volume and capacity analysis of the alternatives"
        title="Capacity Analysis"
      />
      <VcTable rows={rows} />
      <Typography
        sx={{ color: "text.secondary", fontStyle: "italic", marginTop: "15px" }}
      >
        For intersections with multiple nodes the highest v/c is reported
      </Typography>
      <BottomBar
        handleSecondaryButtonClick={handleSecondaryButtonClick}
        mainButtons={[
          {
            label: "PDF Report",
            onClick: () => setShowCapacityReport(true),
          },
          {
            isDisabled: intersections.length > ICE_FORM_XLSX_INTX_CAPACITY,
            label: "ICE Form",
            onClick: () => downloadPennDotIceFormXlsx({ projectData }),
            tooltipText: ICE_FORM_XLSX_INTX_CAPACITY_MESSAGE,
          },
        ]}
        projectData={projectData}
        withSubmitButton={false}
      />
    </StepContainer>
  );
}

CapacityAnalysis.propTypes = {
  handleSecondaryButtonClick: PropTypes.func.isRequired,
  projectData: projectDataPropType.isRequired,
};
